export const helloShared = () => 'hello from shared'

export * from './eventLog'
export * from './logHandledError'
export * from './logger'
